/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 获取订单最小支付金额(订单优惠金额计算)
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  calculateDiscountAmt: order.CalculateDiscountAmt,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.CalculateDiscountRes;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/discount-amt`,
    data: calculateDiscountAmt,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
